import Vue from "vue";
import VueMarkdown from "vue-markdown";
Vue.component("navigation", () => import("@/components/Navigation.vue"));
Vue.component("loading", () => import("@/components/Loading.vue"));
Vue.component("order-info", () => import("@/components/OrderInfo.vue"));
Vue.component("vue-markdown", VueMarkdown);
